import React from 'react';
import './SidePanelScaffold.css';
import '../../Shared.css';
import GenericSideBar from '../../panels/SideBars/GenericSideBar';
import { FaBars } from 'react-icons/fa';
import GenericTopBar from '../../panels/TopBars/GenericTopBar';
import MainTopBar from '../../panels/TopBars/MainTopBar/MainTopBar';

interface Props {
  isLoggedIn: boolean;
  isAdmin: boolean;
  stickyTopBar: boolean;
  isExpanded: boolean;
  showCollapseIcons: boolean;
  onExpandedToggle: () => void;
  topBarChildren?: React.ReactNode;
  sideBarChildren?: React.ReactNode;
  sideBarHeaderChildren?: React.ReactNode; // Custom sidebar header content
  mainPageChildren?: React.ReactNode;
  // User props
  userName?: string;
}

function isReactElementWithProps(
  element: any
): element is React.ReactElement<any> {
  return React.isValidElement(element) && 'props' in element;
}

// TODO remove references of burger
function SidePanelScaffoldPage({
  isLoggedIn,
  isAdmin,
  stickyTopBar,
  isExpanded,
  showCollapseIcons,
  onExpandedToggle,
  topBarChildren,
  sideBarChildren,
  sideBarHeaderChildren,
  mainPageChildren,
  userName,
}: Props): JSX.Element {
  // Hamburger icon for toggling sidebar
  const sideBarOpenButton = (
    <img
      src={'/sidebar_open.png'}
      onClick={onExpandedToggle}
      alt="side bar toggle"
      className="SidePanelScaffoldToggleButton"
      style={{
        marginLeft: '1.25rem',
        marginRight: '0.75rem',
        cursor: 'pointer',
      }}
    />
  );

  const sideBarCloseButton = (
    <img
      src={'/sidebar_close.png'}
      onClick={onExpandedToggle}
      alt="side bar toggle"
      className="SidePanelScaffoldToggleButton"
      style={{ marginRight: '0.5rem', cursor: 'pointer' }}
    />
  );

  // If using a custom topBarChildren, inject the hamburger icon as additionalLeftChildren only when !isExpanded
  let topBarWithHamburger = topBarChildren;
  if (
    topBarChildren &&
    !isExpanded &&
    isReactElementWithProps(topBarChildren)
  ) {
    topBarWithHamburger = React.cloneElement(topBarChildren, {
      additionalLeftChildren: (
        <>
          {sideBarOpenButton}
          {topBarChildren.props.additionalLeftChildren}
        </>
      ),
    });
  }

  return (
    <div className="SidePanelScaffoldContainer">
      <GenericSideBar transition={true} rounded={true} isExpanded={isExpanded}>
        <div className="GenericSideBar-offset">
          <div className="sidePanel-toggle">
            {showCollapseIcons && isExpanded && sideBarCloseButton}
          </div>
          {sideBarHeaderChildren}
        </div>
        {sideBarChildren}
      </GenericSideBar>
      <div className="SidePanelScaffoldPageContainer">
        <div className="SidePanelScaffoldPageTopBarContainer">
          {topBarWithHamburger || (
            <MainTopBar
              isSticky={stickyTopBar}
              isLoggedIn={isLoggedIn}
              showAdminButton={isAdmin}
              userName={userName}
              additionalLeftChildren={
                !isExpanded && showCollapseIcons ? (
                  <>{sideBarOpenButton}</>
                ) : null
              }
            />
          )}
        </div>
        {mainPageChildren}
      </div>
    </div>
  );
}

export default SidePanelScaffoldPage;
